module.exports = __webpack_public_path__ + "img/salasa.89e55c85.webp";